<template>
  <div class="flex gap-2 max-lg:flex-col">
    <nav
      aria-label="Secondary"
      class="inline-flex max-md:w-full"
    >
      <component 
        :is="isLesson ? 'span' : 'a'"
        :href="searchUrl(RecordType.Lesson)"
        class="btn btn--lg rounded-none w-1/2 rounded-l-lg focus-visible:outline-blue-700"
        :class="{ 'text-white bg-blue-600 border-blue-600 pointer-events-none': isLesson }"
      >
        <SvgIcon
          aria-hidden="true"
          icon-name="books"
          width="20"
          height="20"
        />
        <span
          class="sr-only"
          v-html="isLesson ? 'Currently searching' : 'Change search to'"
        />
        <span>Lessons</span>
      </component>
      <component 
        :is="isPath ? 'span' : 'a'"
        :href="searchUrl(RecordType.Path)"
        class="btn btn--lg rounded-none w-1/2 rounded-r-lg focus-visible:outline-blue-700"
        :class="{ 'text-white bg-blue-600 border-blue-600 pointer-events-none': isPath }"
      >
        <SvgIcon
          aria-hidden="true"
          icon-name="signs-post"
          width="20"
          height="20"
        />
        <span
          class="sr-only"
          v-html="isPath ? 'Currently searching' : 'Change to search'"
        />
        <span>Paths</span>
      </component>
    </nav>

    <div class="last-child:mb-0 grid items-end gap-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 w-full">
      <LanguageFilter v-if="isLesson" />
      <AisSearchBox
        autocomplete="off"
        autocorrect="off"
        autocapitalize="none"
        placeholder="Search by Keyword..."
        spellcheck="false"
        show-loading-indicator
        class="w-full"
        :class="{
          'col-span-6': !isLesson,
          'md:col-span-2 xl:col-span-5': isLesson
        }"
      >
        <template #submit-icon>
          <SvgIcon
            aria-hidden="true"
            icon-name="search"
            width="20"
            height="20"
            class="ml-2 shrink-0"
          />
        </template>

        <template #reset-icon>
          <SvgIcon
            aria-hidden="true"
            icon-name="close"
            class="w-3.5"
          />
        </template>
      </AisSearchBox>
    </div>
  </div>
</template>

<script lang="ts">
export default { name: 'SearchFilters' }
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { AisSearchBox } from 'vue-instantsearch/vue3/es'

import { RecordType } from '~/types/records/RecordType'
import { searchUrl } from '~/lib/url'
import LanguageFilter from '~/components/externalContent/lessons/LanguageFilter.vue'

const props = defineProps<{
  recordType: RecordType
}>()

const isLesson = computed<boolean>(() => props.recordType == RecordType.Lesson)
const isPath = computed<boolean>(() => props.recordType == RecordType.Path)

</script>
